import { ChangeEvent, useState } from "react";
import { FieldRenderProps } from "react-final-form";
import { TextArea } from "buba-components-ts";

import styles from "./TextareaWithCounter.scss";

type InputType = FieldRenderProps<any>["input"];
type MetaType = FieldRenderProps<any>["meta"];

interface Props {
  input: InputType;
  meta: MetaType;
  placeholder?: string;
  maxLength?: number;
}

const TextareaWithCounter = ({ input, meta, maxLength, placeholder }: Props) => {
  const [text, setText] = useState("");

  const handleTextareaChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const newText = event.target.value;
    setText(newText);

    if (input.onChange) {
      input.onChange(newText);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey && text.length < (maxLength || +Infinity)) {
      event.preventDefault();
      const target = event.target as HTMLTextAreaElement;
      const { selectionStart, selectionEnd } = target;
      const before = text.substring(0, selectionStart);
      const after = text.substring(selectionEnd);
      const newText = `${before}\n${after}`;

      setText(newText);
      input.onChange(newText);

      setTimeout(() => {
        target.selectionStart = target.selectionEnd = selectionStart + 1;
      }, 0);
    }
  };

  return (
    <div className={styles.container}>
      <TextArea
        input={{
          ...input,
          onChange: handleTextareaChange
        }}
        onKeyDown={handleKeyDown}
        maxLength={maxLength}
        className={styles.input}
        placeholder={placeholder}
      />
      <div className={styles.counter}>
        {text.length}/{maxLength}
      </div>
    </div>
  );
};

export default TextareaWithCounter;
